import React, { useEffect, useState } from 'react';
import { getExportLog } from '../../lib/reportStudioApi';
import { fmtDate } from '../../pages/organization/finance/shared';
import { EmptyState } from '../dashboard/TodaySchedule';

const OPEN_PATHS = { financial_summary: '/reports', players_report: '/reports', attendance_report: '/attendance' };

export default function ExportLogSection() {
  const [log, setLog] = useState(null);
  useEffect(() => { getExportLog(50).then(setLog); }, []);

  if (!log) return <div className="h-40 animate-pulse rounded-xl bg-slate-100" />;
  if (log.length === 0) return <EmptyState icon="document" text="لا يوجد أي تصدير بعد — سيظهر هنا كل عملية PDF أو Excel" testId="rs-log-empty" />;

  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white" data-testid="rs-export-log-table">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs text-slate-500"><tr>
          <th className="px-3 py-2 text-right">التقرير</th>
          <th className="px-3 py-2 text-right">القسم</th>
          <th className="px-3 py-2 text-right">الصيغة</th>
          <th className="px-3 py-2 text-right">المستخدم</th>
          <th className="px-3 py-2 text-right">التاريخ</th>
          <th className="px-3 py-2 text-right">القالب</th>
          <th className="px-3 py-2 text-right">الحالة</th>
          <th className="px-3 py-2 text-right"></th>
        </tr></thead>
        <tbody>
          {log.map((e) => (
            <tr key={e.id} className="border-t border-slate-100" data-testid={`rs-log-row-${e.id}`}>
              <td className="px-3 py-2 font-semibold text-slate-800">{e.report_label}</td>
              <td className="px-3 py-2 text-slate-500">{e.section || '—'}</td>
              <td className="px-3 py-2"><span className={`rounded-full px-2 py-0.5 text-xs font-bold ${e.format === 'pdf' ? 'bg-red-50 text-red-700' : 'bg-teal-50 text-teal-700'}`}>{e.format === 'pdf' ? 'PDF' : 'Excel'}</span></td>
              <td className="px-3 py-2 text-slate-600">{e.user_name}</td>
              <td className="px-3 py-2 text-slate-500">{fmtDate(e.created_at)}</td>
              <td className="px-3 py-2 text-slate-500">{e.template_used || 'الإعدادات العامة'}</td>
              <td className="px-3 py-2"><span className={`rounded-full px-2 py-0.5 text-xs font-bold ${e.status === 'success' ? 'bg-teal-50 text-teal-700' : 'bg-red-50 text-red-600'}`}>{e.status === 'success' ? 'ناجحة' : 'فاشلة'}</span></td>
              <td className="px-3 py-2">
                {OPEN_PATHS[e.report_key] && <a href={OPEN_PATHS[e.report_key]} className="text-xs font-semibold text-teal-700 hover:underline" data-testid={`rs-log-reexport-${e.id}`}>إعادة التصدير ↗</a>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
